import { RequestResponsePattern } from "../../../../../types/Request"
import { postApi } from "../../../../../utils/requestApi"
import { DOMAIN } from "../../../../../var_env."
import { setRequestEditData, setRequestEditError, setRequestEditLoading, setRequestEditMessage } from "../Reducers/ParametroReducer"
import { EditParams } from "../Types/ParametroParams"
import { ParametroType } from "../Types/ParametroType"

export default async function changeLaboratorio(apiController: string, values: any){
    try {
   
        const endpoint = `${DOMAIN}/${apiController}`

        const data = { 
            id: values.id, 
            flagLaboratorio: values.flagLaboratorio,
            idUsuario: values.idUsuario
        }
        
        const response: RequestResponsePattern<ParametroType> = await postApi({ endpoint, data })

        if(response){
      
        }else throw new Error('Erro na requisição')
        
    } catch (error: any) {
       
    }
}